"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTile = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _Text = require("../Text");
var _TextTileModule = _interopRequireDefault(require("./TextTile.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TextTile = exports.TextTile = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    header,
    iconName = 'sparkles',
    classNames,
    description,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: (0, _classify.default)(_TextTileModule.default.textTileWrapper, classNames?.wrapper),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classify.default)(_TextTileModule.default.textTileTitle, classNames?.title),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'title'
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        size: _Icon.ICON_SIZE.large,
        name: iconName,
        type: _Icon.ICON_TYPE.solid,
        className: (0, _classify.default)(_TextTileModule.default.sparkles, classNames?.icon),
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'icon'
        })
      }), typeof header === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.JumboMedium, {
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'header'
        }),
        children: header
      }) : header]
    }), typeof description === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodyLarge, {
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'description'
      }),
      children: description
    }) : description]
  });
});